import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function submitParticulierLead(payload) {
  const { data } = await api.post("/particulier/leads", payload);
  return data;
}

export async function submitSimulatorLead(payload) {
  const { data } = await api.post("/simulator/leads", payload);
  return data;
}

export async function calculateIASimulator(payload) {
  const { data } = await api.post("/ia-simulator/calculate", payload);
  return data;
}

export async function fetchIASimulatorProjects() {
  const { data } = await api.get("/ia-simulator/projects");
  return data.projects || [];
}

export async function requestSimulatorCallback(leadId) {
  const { data } = await api.post("/simulator/callback", { lead_id: leadId });
  return data;
}

export async function uploadParticulierDocuments(leadId, files) {
  const fd = new FormData();
  if (files.avis_imposition) fd.append("avis_imposition", files.avis_imposition);
  if (files.cni_recto_mr) fd.append("cni_recto_mr", files.cni_recto_mr);
  if (files.cni_verso_mr) fd.append("cni_verso_mr", files.cni_verso_mr);
  if (files.cni_recto_mme) fd.append("cni_recto_mme", files.cni_recto_mme);
  if (files.cni_verso_mme) fd.append("cni_verso_mme", files.cni_verso_mme);
  if (files.justif_domicile) fd.append("justif_domicile", files.justif_domicile);
  const { data } = await api.post(`/particulier/leads/${leadId}/documents`, fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}

export async function uploadDocumentsDirect({ first_name, last_name, email, phone, counselor_reference, files }) {
  const fd = new FormData();
  fd.append("first_name", first_name);
  fd.append("last_name", last_name);
  fd.append("email", email);
  fd.append("phone", phone || "");
  fd.append("counselor_reference", counselor_reference || "");
  if (files.avis_imposition) fd.append("avis_imposition", files.avis_imposition);
  if (files.cni_recto_mr) fd.append("cni_recto_mr", files.cni_recto_mr);
  if (files.cni_verso_mr) fd.append("cni_verso_mr", files.cni_verso_mr);
  if (files.cni_recto_mme) fd.append("cni_recto_mme", files.cni_recto_mme);
  if (files.cni_verso_mme) fd.append("cni_verso_mme", files.cni_verso_mme);
  if (files.justif_domicile) fd.append("justif_domicile", files.justif_domicile);
  const { data } = await api.post("/particulier/documents-direct", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
}
